import type {
  PaymentFormType,
  PaymentPayloadType,
  PaymentServerType,
  PaymentType,
} from '@/lib/types/payments.types'

export const serializePaymentForm = (
  data: PaymentFormType,
  advertiserId: number,
): PaymentPayloadType => {
  const userEarnings = data.userEarnings ? Number(data.userEarnings) * 100 : undefined
  const creatorId = data.creatorId ? Number(data.creatorId) : undefined
  const invoiceAmount = data.invoiceAmount ? Number(data.invoiceAmount) * 100 : undefined

  if (!invoiceAmount && !userEarnings && !creatorId) {
    throw new Error(
      'Invalid form data: Either user earnings and creator ID or invoice amount must be provided.',
    )
  }

  if (invoiceAmount) {
    return {
      comment: data.title,
      store_id: advertiserId,
      payment_date: data.paymentDate,
      invoice_amount: invoiceAmount,
      ...(userEarnings && { user_earnings: userEarnings }),
      ...(creatorId && { user_id: creatorId }),
    }
  } else {
    return {
      comment: data.title,
      store_id: advertiserId,
      payment_date: data.paymentDate,
      user_earnings: userEarnings!,
      user_id: creatorId!,
    }
  }
}

export const normalizePayment = (payment: PaymentServerType): PaymentType => {
  return {
    id: payment.id,
    paymentDate: payment.payment_date,
    currencyObj: {
      code: payment.currency_obj?.code,
      name: payment.currency_obj?.name,
      symbol: payment.currency_obj?.symbol,
      subunit: payment.currency_obj?.subunit,
      isBefore: payment.currency_obj?.is_before,
      ratioToEur: payment.currency_obj?.ratio_to_eur,
    },
  }
}

export const normalizePayments = (payments: PaymentServerType[]): PaymentType[] => {
  return payments.map(normalizePayment)
}
